import { SxProps } from '@mui/material/'

export const appBarSx: SxProps = {
  backgroundColor: '#fff',
  boxShadow: 'none',
}

export const titleSx: SxProps = {
  marginLeft: '12px',
  color: 'rgb(32, 35, 41)',
  fontWeight: 900,
}
